import { memo } from 'react';
import ForecastDaySelector from './ForecastDaySelector';

export default memo(ForecastDaySelector);
